/**
 * Guard for Capability Setup: org admins, team managers and platform admins,
 * the rule the backend applies (see capability-setup/access.ts). Anyone else,
 * a program admin who manages no team included, goes to /unauthorized like on
 * the other guarded admin routes.
 */
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useCapabilitySetupAccess } from '../pages/new-designs/tabs/capability-setup/access';

const CapabilitySetupGuard: React.FC = () => {
  const allowed = useCapabilitySetupAccess();
  // Still asking the backend who this is.
  if (allowed === null) return null;
  return allowed ? <Outlet /> : <Navigate to="/unauthorized" replace />;
};

export default CapabilitySetupGuard;
